export default __webpack_public_path__ + "static/media/Koshak-Mahal-1.2aa10467.jpg";